export default __webpack_public_path__ + "static/media/logo.a5c4e972.svg";